import {isPlatformServer} from '@angular/common';
import {inject, PLATFORM_ID, RESPONSE_INIT} from '@angular/core';
import {CanActivateChildFn, Router} from '@angular/router';
import {VpnService} from '@services/vpn/vpn.service';
import {firstValueFrom} from 'rxjs';
import {guardRedirect} from './guard-redirect';

/**
 * Guard to check if the user is connected to the VPN.
 * Only enforced on client-side (not during server-side rendering).
 * Redirects to the vpn-disconnected page if the user is not connected.
 */
export const privateDataEnclaveVpnGuard: CanActivateChildFn = async (childRoute, _state) => {
  const router = inject(Router);
  const response = inject(RESPONSE_INIT, {optional: true});
  const vpnService = inject(VpnService);
  const isServerSide = isPlatformServer(inject(PLATFORM_ID));

  // Skip VPN check during server-side rendering
  if (isServerSide) return true;

  const isConnected = await firstValueFrom(vpnService.isConnected);
  return isConnected ? true : guardRedirect('/vpn-disconnected', router, response);
};
